import type {
  ApplicationValidationError,
  EnumLiteralCreateOperation,
} from '@festina/configuration-general-types/configuration'

import { enumLiteralPath } from '../../system/paths'
import type { ValidationErrorWithLocation } from '../../uiModels/errors/types'
import type { OperationWithSourceInfo } from '../../uiModels/types'
import { ConfigurationItemOperationsWithErrors } from './ConfigurationItemOperationsWithErrors'
import type { OperationsListVariant } from './types'

type Props = {
  errors: ValidationErrorWithLocation<ApplicationValidationError>[]
  operations: OperationWithSourceInfo<EnumLiteralCreateOperation>[]
  variant: OperationsListVariant
}

/** Literals are grouped by their qualified name, as their own name is only unique within their enum. */
const qualifiedLiteralName = (operation: EnumLiteralCreateOperation) =>
  `${operation.entity?.enumName}.${operation.entity?.name}`

const splitQualifiedLiteralName = (qualifiedName: string) => {
  const [enumName, literalName] = qualifiedName.split('.')

  return { enumName, literalName }
}

export const EnumLiteralOperationsWithErrors = ({
  operations,
  errors,
  variant,
}: Props) => (
  <ConfigurationItemOperationsWithErrors
    operations={operations}
    errors={errors}
    variant={variant}
    itemIdFromOperation={qualifiedLiteralName}
    link={{
      type: 'enumLiteral',
      itemId: (qualifiedName) =>
        splitQualifiedLiteralName(qualifiedName).enumName,
      itemLabel: (qualifiedName) => qualifiedName,
      propertyPath: (qualifiedName) =>
        enumLiteralPath(splitQualifiedLiteralName(qualifiedName)),
    }}
  />
)
